














import { Component, Vue, Inject } from 'vue-property-decorator';

@Component
export default class DocumentPage extends Vue {
  @Inject({ from: 'isPdf', default: false }) public isPdf!: boolean;
  public padding = 40;
}
